import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Colors from "../../common/Colors";
import Modal from "../../components/Modal";
import Header from "../../components/Header";
import axios from "axios";
import Toast from "../../components/Toast";
import SwitchTable from "../../components/SwitchTable";
import { root_url } from "../../services/API";

class ListCategoryScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        pending: [],
        approved: [],
        rejected: [],
        // closed: []
      },
      active: "table",
      version: 0,
      modleVisible: false,
      modalData: null,
      toast: {
        open: false,
        message: "",
        severity: "success"
      },
      filters: {
        bookingType: "table"
      },
      switchTableOpen: false,
      selectedTokenOrderId: null,
      isLoading: false
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }

  componentDidMount() {
    this.fetchKanbanData();
  }

  fetchKanbanData = async () => {
    try {
      this.setState({ isLoading: true });
      const hotelId = this.props.selectedHotelId?.id;
      const token = localStorage.getItem('token');
      const { bookingType } = this.state.filters;

      // Determine which API endpoint to use based on bookingType
      const endpoint = bookingType === "table" 
        ? `${root_url}/api/hotelowner/booking/kanban-table/${hotelId}`
        : `${root_url}/api/hotelowner/booking/kanban_hall/${hotelId}`;

      const response = await axios.get(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      
      const result = response.data;
      
      if (result.status === "success") {
        this.setState({
          data: {
            pending: result.data.pending || [],
            approved: result.data.approved || [],
            rejected: result.data.rejected || [],
            // closed: result.data.closed || []
          },
          isLoading: false
        });
      } else {
        this.showToast(result.message || "Failed to fetch bookings", "error");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      this.showToast("An error occurred while fetching bookings", "error");
      this.setState({ isLoading: false });
    }
  }

  handleAction = async (booking, status) => {
    try {
      const { status: apiStatus, message } = await API(this, "post", URL_PATH.updateBookingStatus, {
        booking_id: booking.id,
        status: status,
      });
      
      if (apiStatus === "success") {
        this.showToast(message, "success");
        this.fetchKanbanData();
      } else {
        this.showToast(message, "error");
      }
    } catch (error) {
      this.showToast("Failed to update booking status", "error");
    }
  }

  handleAssignTable = (booking) => {
    this.setState({
      switchTableOpen: true,
      selectedTokenOrderId: booking.id,
      method: "order"
    });
  };

  handleFilterChange = (filterName, value) => {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterName]: value
      }
    }), () => {
      this.fetchKanbanData();
    });
  }

  openBookingDetails = (booking) => {
    this.setState({
      modalData: booking,
      modleVisible: true,
    });
  }

  closeModal = () => {
    this.setState({ modleVisible: false });
  }

  handleDragEnd = (result) => {
    const { source, destination } = result;

    // If dropped outside the list or in the same position
    if (!destination || 
        (source.droppableId === destination.droppableId && 
         source.index === destination.index)) {
      return;
    }

    const sourceColumn = source.droppableId;
    const destColumn = destination.droppableId;
    const draggedItem = this.state.data[sourceColumn][source.index];

    // Define allowed status transitions
    const allowedTransitions = {
      pending: ["approved", "rejected"],  // Can only move to approved or rejected
      approved: [],                       // Cannot be moved from approved (must assign table first)
      rejected: [],                       // Cannot be moved from rejected
      // closed: []                       // Cannot be moved from closed
    }

    // Check if this transition is allowed
    if (!allowedTransitions[sourceColumn].includes(destColumn)) {
      return;
    }

    // Map to actual status values
    const statusMapping = {
      pending: "pending",
      approved: "approved",
      rejected: "rejected",
      // closed: "closed"
    }

    // First update the status on server
    this.handleAction(draggedItem, statusMapping[destColumn])

    // Then update local state if server update was successful
    const newData = { ...this.state.data }
    newData[sourceColumn] = [...this.state.data[sourceColumn]]
    newData[sourceColumn].splice(source.index, 1)
    newData[destColumn] = [...this.state.data[destColumn]]
    newData[destColumn].splice(destination.index, 0, draggedItem)

    this.setState({ data: newData })
  }

  renderBookingCard = (booking, columnId, index) => {
    const status = booking.latest_status?.status || "pending";
    const type = booking.booking_type;
    
    const statusColors = {
      pending: { bg: "#FEF3C7", text: "#92400E", border: "#FFC857" },
      approved: { bg: "#DCFCE7", text: "#166534", border: "#00A651" },
      rejected: { bg: "#FEE2E2", text: "#B91C1C", border: "#BB0A21" },
      closed: {
        bg: "rgba(255, 107, 107, 0.15)",     // Light red background (15% opacity)
        text: "rgba(255, 107, 107, 0.9)",    // Light red text (90% opacity)
        border: "#FF6B6B"                    // Original solid border
      }
    };

    const currentStatusColor = statusColors[status] || statusColors.pending;

    return (
      <Draggable key={booking.id.toString()} draggableId={booking.id.toString()} index={index}>
        {(provided) => (
          <div 
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              backgroundColor: "#02111B",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "16px",
              borderLeft: `4px solid ${currentStatusColor.border}`,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <span style={{ fontWeight: "600", color: "white" }}>Booking #{booking.id}</span>
              <span style={{ fontSize: "12px", color: "#9CA3AF" }}>
                {moment(booking.booking_on_date).fromNow()}
              </span>
            </div>
            
            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: currentStatusColor.bg,
                color: currentStatusColor.text,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "8px",
                fontWeight: "bold",
                fontSize: "14px"
              }}>
                {booking.user?.name?.charAt(0)?.toUpperCase() || "?"}
              </div>
              <div>
                
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {/* Left: User info */}
                <div>
                  <div style={{ fontWeight: "500", color: "white" }}>
                    {booking.user?.name?.split(" ")[0] || "Unknown"}
                  </div>
                  
                  {booking.user?.mobile && (
                    <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                      {booking.user.mobile}
                    </div>
                  )}
                </div>

                {/* Right: Event name */}
                {type === "hall" && booking.function_event && (
                  <div>
                    <span style={{ 
                      color: "white",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      }}>
                      {booking.function_event}
                    </span>
                  </div>
                )}
              </div>
            </div>
            
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              marginTop: "12px",
              paddingTop: "12px",
              borderTop: "1px solid #6B7280"
            }}>
            {booking.booking_type === "table" && (
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <span style={{ color: "white", fontSize: "14px" }}>
                  {booking.no_of_peoples} {booking.no_of_peoples > 1 ? "people" : "person"}
                </span>
              </div>
            )}
              
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={() => this.openBookingDetails(booking)}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#0D6EFD",
                    color: "white",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "600",
                    gap: "4px"
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  View
                </button>
                
                {status === "pending" && (
                  <>
                    <button
                      onClick={() => this.handleAction(booking, "approved")}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#00A651",
                        color: "white",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600"
                      }}
                    >
                      Accept
                    </button>
                    <button
                      onClick={() => this.handleAction(booking, "rejected")}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#BB0A21",
                        color: "white",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600"
                      }}
                    >
                      Reject
                    </button>
                  </>
                )}

                {status === "approved" && type === "table" && (
                  <>
                    <button
                      onClick={() => this.handleAssignTable(booking)}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#FFC857",
                        color: "black",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600"
                      }}
                    >
                      Assign
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
  }

  render() {
    const { data, filters, isLoading } = this.state;
    const columnTitles = {
      pending: "In Review",
      approved: "Approved",
      rejected: "Rejected",
      // closed: "Closed"
    };

    const columnColors = {
      pending: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#FFC857",
        countText: "black"
      },
      approved: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#00A651",
        countText: "white"
      },
      rejected: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#BB0A21",
        countText: "white"
      },
      // closed: {
      //   headerBg: "#E0E7FF",
      //   headerText: "#4338CA",
      //   countBg: "#FF6B6B",
      //   countText: "white"
      // }
    };

    return (
      <div className="container-fluid" style={{ padding: "24px", backgroundColor: "#02111B", minHeight: "100vh" }}>
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        {this.state.switchTableOpen && (
          <SwitchTable
            onCancel={() => {
              this.setState({ switchTableOpen: false });
            }}
            handleSuccess={() => {
              this.setState({ switchTableOpen: false });
              this.fetchKanbanData();
            }}
            isOpen={this.state.switchTableOpen}
            orderId={this.state.selectedTokenOrderId}
            method={"booking"}
          />
        )}
        
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px"
        }}>
          <Header title="Bookings" subtitle="Manage table and hall bookings" />
          
          <div style={{ display: "flex", gap: "20px" }}>
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", gap: "20px" }}>
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="bookingType" 
                    value="hall"
                    checked={filters.bookingType === "hall"}
                    onChange={(e) => this.handleFilterChange('bookingType', e.target.value)}
                    style={{ marginRight: "8px", accentColor: "#FFC857" }}
                  />
                  <span style={{ color: "white" }}>Hall Booking</span>
                </label>
                
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="bookingType"
                    value="table"
                    checked={filters.bookingType === "table"}
                    onChange={(e) => this.handleFilterChange('bookingType', e.target.value)}
                    style={{ marginRight: "8px", accentColor: "#FFC857" }}
                  />
                  <span style={{ color: "white" }}>Table Booking</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {isLoading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px"
          }}>
            {/* Loading spinner can be added here */}
          </div>
        ) : (
          <DragDropContext onDragEnd={this.handleDragEnd}>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "24px",
              alignItems: "start"
            }}>
              {Object.keys(data).map((columnId) => {
                const columnData = data[columnId];
                const columnCount = columnData.length;
                const columnStyle = columnColors[columnId] || columnColors.pending;

                return (
                  <div key={columnId} style={{
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    overflow: "hidden",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column"
                  }}>
                    {/* Header section */}
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                      backgroundColor: columnStyle.headerBg,
                      borderBottom: "1px solid #6B7280",
                      flexShrink: 0
                    }}>
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}>
                        <span style={{
                          fontWeight: "600",
                          color: columnStyle.headerText,
                          fontSize: "16px"
                        }}>
                          {columnTitles[columnId]}
                        </span>
                      </div>
                      <span style={{
                        backgroundColor: columnStyle.countBg,
                        color: columnStyle.countText,
                        borderRadius: "9999px",
                        padding: "4px 10px",
                        fontSize: "12px",
                        fontWeight: "600"
                      }}>
                        {columnCount}
                      </span>
                    </div>
                    
                    {/* Scrollable content section */}
                    <Droppable droppableId={columnId}>
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            padding: "16px",
                            backgroundColor: "#041A29",
                            overflowY: "auto",
                            flexGrow: 1,
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                            maxHeight: "calc(100vh - 200px)"
                          }}
                        >
                          {columnData.length === 0 ? (
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "300px",
                              color: "#9CA3AF",
                              textAlign: "center"
                            }}>
                              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 10H21M7 3V5M17 3V5M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              <p style={{ marginTop: "8px" }}>No bookings in this category</p>
                            </div>
                          ) : (
                            columnData.map((booking, index) => this.renderBookingCard(booking, columnId, index))
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                );
              })}
            </div>
          </DragDropContext>
        )}

        {/* Booking Details Modal */}
        {this.state.modleVisible && this.state.modalData && (
          <Modal
            visible={this.state.modleVisible}
            onClose={this.closeModal}
            title={`Booking #${this.state.modalData.id} Details`}
          >
            <div style={{ padding: "16px", color: "white" }}>
              <div style={{ marginBottom: "16px" }}>
                <h4 style={{ color: "#FFC857", marginBottom: "12px" }}>Customer Information</h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Name</p>
                    <p>{this.state.modalData.user?.name || "N/A"}</p>
                  </div>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Mobile</p>
                    <p>{this.state.modalData.user?.mobile || "N/A"}</p>
                  </div>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Email</p>
                    <p>{this.state.modalData.user?.email || "N/A"}</p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <h4 style={{ color: "#FFC857", marginBottom: "12px" }}>Booking Information</h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Type</p>
                    <p>{this.state.modalData.booking_type}</p>
                  </div>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>People</p>
                    <p>{this.state.modalData.no_of_peoples}</p>
                  </div>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Booked On</p>
                    <p>{moment(this.state.modalData.booking_on_date).format("LLL")}</p>
                  </div>
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>From</p>
                    <p>{moment(this.state.modalData.booking_from_date_time).format("LLL")}</p>
                  </div>
                  {this.state.modalData.booking_type === "hall" && this.state.modalData.booking_to_date_time && (
                    <div>
                      <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>To</p>
                      <p>{moment(this.state.modalData.booking_to_date_time).format("LLL")}</p>
                    </div>
                  )}
                  <div>
                    <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Status</p>
                    <p>{this.state.modalData.latest_status?.status || "Unknown"}</p>
                  </div>
                  {this.state.modalData.function_event && (
                    <div>
                      <p style={{ color: "#9CA3AF", marginBottom: "4px" }}>Event</p>
                      <p>{this.state.modalData.function_event}</p>
                    </div>
                  )}
                </div>
              </div>

              {this.state.modalData.payments && this.state.modalData.payments.length > 0 && (
                <div style={{ marginBottom: "16px" }}>
                  <h4 style={{ color: "#FFC857", marginBottom: "12px" }}>Payment Information</h4>
                  <div style={{ 
                    backgroundColor: "#1F2937", 
                    borderRadius: "8px", 
                    padding: "12px",
                    overflowX: "auto"
                  }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ borderBottom: "1px solid #374151" }}>
                          <th style={{ 
                            padding: "8px", 
                            textAlign: "left", 
                            color: "#9CA3AF",
                            fontSize: "14px"
                          }}>Payment ID</th>
                          <th style={{ 
                            padding: "8px", 
                            textAlign: "left", 
                            color: "#9CA3AF",
                            fontSize: "14px"
                          }}>Amount</th>
                          <th style={{ 
                            padding: "8px", 
                            textAlign: "left", 
                            color: "#9CA3AF",
                            fontSize: "14px"
                          }}>Status</th>
                          <th style={{ 
                            padding: "8px", 
                            textAlign: "left", 
                            color: "#9CA3AF",
                            fontSize: "14px"
                          }}>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.modalData.payments.map(payment => (
                          <tr key={payment.id} style={{ borderBottom: "1px solid #374151" }}>
                            <td style={{ 
                              padding: "8px", 
                              color: "white",
                              fontSize: "14px"
                            }}>{payment.id}</td>
                            <td style={{ 
                              padding: "8px", 
                              color: "white",
                              fontSize: "14px"
                            }}>₹{payment.orderAmount}</td>
                            <td style={{ 
                              padding: "8px", 
                              color: "white",
                              fontSize: "14px"
                            }}>
                              <span style={{
                                backgroundColor: payment.payment_status === "completed" ? "#00A651" : "#BB0A21",
                                color: "white",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontSize: "12px"
                              }}>
                                {payment.payment_status}
                              </span>
                            </td>
                            <td style={{ 
                              padding: "8px", 
                              color: "white",
                              fontSize: "14px"
                            }}>{moment(payment.orderCreatedAt).format("LLL")}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "24px" }}>
                <button
                  onClick={this.closeModal}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#041A29",
                    color: "white",
                    border: "1px solid #6B7280",
                    borderRadius: "6px",
                    cursor: "pointer"
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default redux(ListCategoryScreen);